/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Typography, InputNumber, Row, Tooltip } from "antd";
import { SwitchWrapper, TooltipText } from "./Insurance.styles";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Column, InputWrapper } from "../../ProductInfo/ProductInfo.styles";
import Switch from "../Switch";

const { Text } = Typography;

interface Props {
  isEditing: boolean | undefined;
  insuranceRequired: boolean;
  insuranceValue: number | null;
  handleInsuranceValueChange: (value: number) => void;
  handleInsuranceRequiredChange: (value: boolean) => void;
  isIkeaOrg?: boolean;
}

const Insurance: React.FC<Props> = ({
  isEditing,
  insuranceRequired,
  insuranceValue,
  handleInsuranceValueChange,
  handleInsuranceRequiredChange,
  isIkeaOrg,
}) => {
  useEffect(() => {
    handleInsuranceValueChange(insuranceValue || 0);
    handleInsuranceRequiredChange(insuranceRequired);
  }, [insuranceValue]);

  const renderTitle = () => (
    <Tooltip
      overlayStyle={{ minWidth: "450px" }}
      placement="bottom"
      title={
        <>
          <TooltipText strong>Insurance will only apply to parcel shipments. </TooltipText>
          <TooltipText>Adding insurance to a product will increase the overall shipment cost.</TooltipText>
        </>
      }
    >
      <Text type="secondary">Insurance {<InfoCircleOutlined />}</Text>
    </Tooltip>
  );

  const renderEditInsurance = () => (
    <>
      {isIkeaOrg && (
        <>
          <Column flex={3}>
            {renderTitle()}
            <Row>
              <InputWrapper width="80%">
                <SwitchWrapper>
                  <Switch
                    checkedChildren="On"
                    unCheckedChildren="Off"
                    checked={insuranceRequired}
                    handleChange={(checked) => {
                      handleInsuranceRequiredChange(checked);
                    }}
                  />
                </SwitchWrapper>
              </InputWrapper>
            </Row>
          </Column>
          <Column flex={3}>
            <Text type="secondary">Insurance Value</Text>
            <InputWrapper width="80%">
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Add $ value"
                size="large"
                min={1}
                max={50000}
                formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                value={insuranceValue || 0}
                disabled={!insuranceRequired}
                onChange={(e) => {
                  handleInsuranceValueChange(e);
                }}
              />
            </InputWrapper>
          </Column>
        </>
      )}

      {!isIkeaOrg && (
        <>
          {renderTitle()}
          <Row>
            <Column flex={10}>
              <SwitchWrapper>
                <Switch
                  checkedChildren="On"
                  unCheckedChildren="Off"
                  checked={insuranceRequired}
                  handleChange={(checked) => {
                    handleInsuranceRequiredChange(checked);
                  }}
                />
              </SwitchWrapper>
            </Column>

            <Column flex={12}>
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Add $ value"
                size="large"
                min={1}
                max={50000}
                formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                value={insuranceValue || 0}
                disabled={!insuranceRequired}
                onChange={(e) => {
                  handleInsuranceValueChange(e || 0);
                }}
              />
            </Column>
          </Row>
        </>
      )}
    </>
  );

  const renderViewInsurance = () => (
    <>
      {isIkeaOrg && (
        <>
          <Column flex={3}>
            {renderTitle()}

            <Text>
              <b>{insuranceRequired ? `Yes` : "No"}</b>
            </Text>
          </Column>
          <Column flex={3}>
            <Text type="secondary">Insurance Value</Text>
            <Text>
              <b>
                {insuranceRequired
                  ? `$${insuranceValue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} value`
                  : "N/A"}
              </b>
            </Text>
          </Column>
        </>
      )}
      {!isIkeaOrg && (
        <>
          {renderTitle()}
          <Text>
            <b>
              {insuranceRequired
                ? `Yes ($${insuranceValue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")} value)`
                : "No"}
            </b>
          </Text>
        </>
      )}
    </>
  );

  return <> {isEditing ? renderEditInsurance() : renderViewInsurance()}</>;
};

export default Insurance;
